import React from 'react';
import { PublicAccApplyUserStatusVO } from '../../../../../domain/vo/acca/v1/test/result/PublicAccApplyUserStatusVO';
import { analysisTypeStringMap } from '@domain/constant/analysisType';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './title.module.scss';

const cx = classnames.bind(styles);

interface TitleProps {
  userStatus: PublicAccApplyUserStatusVO | null;
}

const Title = ({ userStatus }: TitleProps) => {
  const getContents = (contents: string) => {
    if (contents) return contents + ', ';
    return null;
  };

  if (!userStatus) return null;

  const { name, schoolName, majorName, analysisType, analysisCompletionTime } = userStatus;
  const dateTime = DateFormat.format(new Date(analysisCompletionTime), 'yyyy.MM.dd HH:mm');

  return (
    <div className={cx('titleArea')}>
      <strong className={cx('title')}>
        {getContents(name)}
        {getContents(schoolName)}
        {getContents(majorName)}
        {analysisTypeStringMap[analysisType]}
      </strong>
      {analysisCompletionTime && <span className={cx('date')}>({dateTime})</span>}
    </div>
  );
};

export default Title;
